module.exports = __webpack_public_path__ + "media/assets/services_manager/logos/mb_chat-3ff2fcfccfc34c40e8dc08cf0ef5119d2634d5c408fc8f78717a2e116ae3aeb9.png";